<!-- If print should be enabled for detailed graph, replace agr-page-toolbar hasPrimaryAction with: [hasPrimaryAction]="!isDataEmpty" -->
<agr-page-toolbar
  [pageTitle]="'app.farmer-insights' | translate"
  [hasPrimaryAction]="
    !isDataEmpty && !((selectedViewMode$ | async) === 'Chart' && (isDetailedView$ | async) === true)
  "
  primaryActionIcon="print"
  [primaryActionText]="'print' | translate"
  (primaryAction)="print()"
  [isEmpty]="isDataEmpty"
  [emptyTitle]="'farmer-insights.no-data.title' | translate"
  [emptyDescription]="'farmer-insights.no-data.description' | translate"
  emptyImage="assets/images/flock-cycle.jpg"
>
  <ng-container actions>
    <div class="farmer-insights-actions">
      <button
        *ngIf="!isDataEmpty"
        mat-flat-button
        class="spacing--margin-right"
        (click)="openSettings()"
        data-test="farmer-insights-open-benchmark-settings"
      >
        <mat-icon>settings</mat-icon>
        {{ 'farmer-insights.benchmark-settings' | translate }}
      </button>
    </div>
  </ng-container>

  <agr-print-page
    footerText="PoultryNEXT - Farmer Insights"
    [customizedLogoSrc]="customizedLogoSrc"
    [showAgrifirmLogo]="showAgrifirmLogo"
    [orientation]="printOrientation"
  >
    <div class="wrapper--spacing-horizontal">
      <app-data-filter class="screen-only"></app-data-filter>
      <app-data-view></app-data-view>
    </div>
  </agr-print-page>
</agr-page-toolbar>
